<template>
  <div class="rejected-list">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        产品信息
      </div>
      <div style="margin:10px 10px 10px 0;display:inline-block">
        退货地址：
        {{ rejectedList.rfullAddress }}
        {{ rejectedList.rreceiveUserName }}
        {{ rejectedList.rreceiveTel }}
      </div>
      <!-- <el-button type="primary" v-if="this.$route.query.contratType!=='齐套不提货撤单'" @click="setSerialNum">批量选择退货产品序列号</el-button> -->
      <div class="rj-page-card__content">
        <el-table
          :data="rejectedList.contractProductList"
          border
          style="width: 100%"
          :summary-method="getSummaries" show-summary
        >
          <el-table-column
            prop="ritemIndex"
            label="序号"
            width="180"
            align="left"
            fixed="left"
          />
          <el-table-column
            prop="rproductCode"
            label="销售产品代码"
            width="120"
            align="left"
            fixed="left"
          />
          <el-table-column
            prop="rproductInvoiceName"
            label="商品名称"
            align="left"
            width="180"
          />
          <el-table-column
            prop="rproductName"
            label="产品型号"
            align="left"
            width="180"
          />
          <el-table-column
            prop="rmaterialUnit"
            label="单位"
            align="left"
            width="180"
          />
          <el-table-column
            prop="rproductNum"
            label="数量"
            align="left"
            width="180"
          >
            <template slot-scope="{ row }">
              -{{ row.rproductNum }}
            </template>
          </el-table-column>
          <el-table-column
            prop="rproductPrice"
            label="单价"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="rproductPriceAdd"
            label="订单金额"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="rproductActualPriceAdd"
            label="实际结算金额"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="rbeforeSplitPrice"
            label="拆分前单价"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="rfictitiousReturn"
            label="真实/虚拟退货"
            align="left"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.rfictitiousReturn">真实退</span>
              <span v-if="!scope.row.rfictitiousReturn">虚拟退</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { MathAdd } from '@/libs/util';
export default {
  name: 'RejectedList',
  data () {
    return {
      rejectedList: this.productData,
      dialogVisibleBool: false,
      setSerialData: {}
    };
  },
  props: {
    productData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    productData (val) {
      this.rejectedList = val;// 暂时取 0 个
    }
  },
  components: {
  },
  methods: {
    // 设置序列号
    setSerialNum () {
      this.dialogVisibleBool = true;
      this.setSerialData = {
        'contractId': 1,
        'getGoodsList': 2
      };
      // this.$notify.error({
      //   message: '设置冲销序列号'
      // });
    },
    setSerialClose (val) {
      this.dialogVisibleBool = val;
    },
    getTableData (val) {
      this.rejectedList = val;
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        // if (this.productData.contractProductList.length !== 0) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = '-' + this.AmountTotal(param.data);
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.orderAmount(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.rproductActualPriceAdd(param.data);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.rbeforeSplitPrice(param.data);
        }
        // }
      });
      return sums;
    },
    // 数量总计
    AmountTotal (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductNum);
      });
      return cont;
    },
    // 订单金额总计
    orderAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductPriceAdd);
      });
      return cont;
    },
    // 实际结算金额总计
    rproductActualPriceAdd (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductActualPriceAdd);
      });
      return cont;
    },
    // 拆分前单价总计
    rbeforeSplitPrice (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rbeforeSplitPrice);
      });
      return cont;
    }
  }
};
</script>

<style lang="scss">

</style>
